export enum AdVideoStatus {
  ready = 'ready',
  processing = 'processing',
  error = 'error',
}

export interface AdVideo {
  id: number;
  embeddedHtml: string;
  length: number;
  permalinkUrl: string;
  source?: string;
  status: AdVideoStatus;
  processingProgress?: number;
  thumbnail?: string;
  title?: string;
  createdAt: number;
  updatedAt: number;
}

export const exampleAdVideo: AdVideo = {
  id: 1,
  embeddedHtml: '<iframe />',
  length: 12.34,
  permalinkUrl: 'link.me/fb',
  source: 'https://image.com',
  status: AdVideoStatus.ready,
  thumbnail: 'https://image.com',
  title: 'New Video',
  createdAt: 1595533091,
  updatedAt: 1595533091,
};
